module.exports = __webpack_public_path__ + "static/media/worker.107e7f13.jpg";